import {
  VisuallyHiddenProps as MantineVisuallyHiddenProps,
  VisuallyHidden as MantineVisuallyHidden,
} from '@mantine/core';

export type VisuallyHiddenProps = MantineVisuallyHiddenProps;

export const VisuallyHidden = MantineVisuallyHidden;

VisuallyHidden.displayName = 'VisuallyHidden';
